"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountScreen = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var sign_out_thunk_1 = require("../../../reducers/slices/thunks/sign_out_thunk");
var react_redux_1 = require("react-redux");
var bidding_history_1 = require("./bidding_history");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var user_details_1 = require("./user_details");
var main_1 = require("../../../reducers/slices/main");
var AccountScreen = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    return (react_1.default.createElement("div", { className: "pt-10 flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex flex-row justify-between items-center" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Account", size: "3xlarge", bold: true, textColor: "text-black" }),
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Log Out", textColor: "text-black", icon: pro_solid_svg_icons_1.faSignOut, onClick: function () {
                    dispatch((0, sign_out_thunk_1.sign_out_thunk)());
                } })),
        react_1.default.createElement("div", { className: "flex flex-row justify-end" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Bidding History", size: "xsmall", backgroundColor: "bg-secondary", onClick: function () {
                    dispatch((0, main_1.setDrawer)({
                        open: true,
                        content: react_1.default.createElement(bidding_history_1.BiddingHistoryComponent, null),
                    }));
                } })),
        react_1.default.createElement(user_details_1.UserDetails, null)));
};
exports.AccountScreen = AccountScreen;
